import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { useLocationsDropdown } from '../../../../../APIs/common';
import { ConfigContext } from '../../../../../contexts/ConfigContext';
import { reactSelectDark } from '../../../../../styles/reactSelectDarkTheme';
import { reactSelectLight } from '../../../../../styles/reactSelectLightTheme';

export default function LocationFilter() {
  const config = useContext(ConfigContext);

  const [selectedLocation, setSelectedLocation] = useState(null);

  const { locations, isLoading } = useLocationsDropdown();

  const locationOptions =
    locations?.map((loc) => ({
      value: loc.id,
      label: loc.name,
      isPrimary: loc.is_primary
    })) || [];

  const handleChange = (loc) => {
    if (!loc?.value) return;

    setSelectedLocation(loc);

    window.dispatchEvent(
      new CustomEvent('calendar-location-change', {
        detail: loc
      })
    );
  };

  useEffect(() => {
    if (selectedLocation || locationOptions.length === 0) return;

    const primaryLocation = locationOptions.find((loc) => loc.isPrimary) || locationOptions[0];

    handleChange(primaryLocation);
  }, [locationOptions, selectedLocation]);

  return (
    <div className="md">
      <Select
        options={locationOptions}
        value={selectedLocation}
        onChange={handleChange}
        isLoading={isLoading}
        placeholder="Select Location"
        menuPortalTarget={document.body}
        styles={{
          container: (base) => ({
            ...base
            // width: 200
            // marginLeft: 8
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 99999
          }),
          menu: (base) => ({
            ...base,
            zIndex: 99999
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: 160
          }),
          ...(config.mode === 'dark' ? reactSelectDark : reactSelectLight),
          control: (base) => ({
            ...base,
            height: '40px',
            backgroundColor: 'transparent'
          })
        }}
      />
    </div>
  );
}
